// extracted by mini-css-extract-plugin
export default {"mainContainer":"ClaimValidationModal_mainContainer__i0gHx"};